export default __webpack_public_path__ + "static/media/flag-spain-active.04e07d47.svg";